/*
 * View for the config area of the learner
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/learner/learnerConfig/template/learnerConfigTemplate.html",
  "i18n/i18n",
  "jquery-ui",
  "jquery-ui/ui/widgets/datepicker",
  "jquery-ui/ui/widgets/slider",
], function (Marionette, Messenger, LearnerConfigTemplate) {
  "use strict";

  const LearnerConfigView = {};

  LearnerConfigView.learnerConfigView = Marionette.ItemView.extend({
    template: LearnerConfigTemplate,
    events: {
      "click #cluster": function () {
        this.$el.find("#clusterSliderControlGroup").fadeToggle();
        this.$el.find("#learnerFilterArea").fadeToggle();
        this.resetClusteringJob();
      },
      "change #matchType": "resetClusteringJob",
      "change #authoringStatus": "resetClusteringJob",
      "change #locale": "resetClusteringJob",
      "change #touchpoint": "resetClusteringJob",
      "change #startDate": "resetClusteringJob",
      "change #startTime": "resetClusteringJob",
      "change #endDate": "resetClusteringJob",
      "change #endTime": "resetClusteringJob",
    },
    ui: {
      learnerSearch: "#learnerSearch",
    },
    templateHelpers: {
      getDateDisplay: function (date) {
        return Messenger.reqres.request("get:formatted:date", date);
      },
    },
    disableLearnerSearch: function () {
      this.ui.learnerSearch.attr("disabled", true);
    },
    enableLearnerSearch: function () {
      this.ui.learnerSearch.attr("disabled", false);
    },
    getLearnerConfig: function () {
      const startDate = this.$el.find("#startDate").datepicker("getDate").getTime();
      const startTime = parseInt(this.$el.find("#startTime option:selected").val(), 10);
      const endDate = this.$el.find("#endDate").datepicker("getDate").getTime();
      const endTime = parseInt(this.$el.find("#endTime option:selected").val(), 10);
      const touchpoints = this.$el.find("#touchpoint option:selected");
      let touchpointIDs = "";
      for (let i = 0; i < touchpoints.length; i++) {
        touchpointIDs = touchpointIDs + touchpoints[i].value;
        if (i < touchpoints.length - 1) {
          touchpointIDs = touchpointIDs + "_";
        }
      }
      const isSemanticKb = this.model.isSemanticKb;
      let threshold;
      if (isSemanticKb) {
        threshold = this.model.getSemanticThreshold(
          this.$el.find("#clusterSlider").slider("value"),
        );
      } else {
        threshold = this.model.getThreshold(this.$el.find("#clusterSlider").slider("value"));
      }
      return {
        matchType: this.$el.find("#matchType option:selected").val(),
        authoringStatus: this.$el.find("#authoringStatus option:selected").val(),
        touchpoint: touchpointIDs,
        localeId: parseInt(this.$el.find("#locale option:selected").val(), 10),
        startDate: startDate + startTime,
        endDate: endDate + endTime,
        cluster: this.$el.find("#cluster").prop("checked"),
        threshold: threshold,
      };
    },
    onRender: function () {
      this.$el.i18n();
      const endDate = this.$el.find("#endDate");
      //get the language code for use by the datepicker for i18n
      const langCode = Messenger.reqres.request("get:interface:language");
      //get the format of the date to use by the datepicker
      const format = Messenger.reqres.request("get:datepicker:date:format");
      endDate.datepicker({
        format: format,
        endDate: "0d",
        language: langCode,
        autoclose: true,
      });

      this.$el.find("#startDate").datepicker({
        format: format,
        endDate: "0d",
        language: langCode,
        autoclose: true,
      });
      //create clustering slider
      const isSemanticKb = this.model.isSemanticKb;
      if (isSemanticKb) {
        this.$el.find("#clusterSlider").slider({
          classes: {
            "ui-slider-handle": "btn btn-astute",
          },
          max: 9,
          min: 1,
          step: 1,
          value: this.model.get("selectedClusterThresholdSliderValue") || 5,
        });
      } else {
        this.$el.find("#clusterSlider").slider({
          classes: {
            "ui-slider-handle": "btn btn-astute",
          },
          max: 5,
          min: 1,
          step: 1,
          value: 3,
        });
      }
    },
    resetClusteringJob: function () {
      this.trigger("reset:clustering:job");
    },
    triggers: {
      "click #learnerSearch": "click:search",
    },
  });

  return LearnerConfigView;
});
